var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarcaDootax({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1457,
    height: 292,
    viewBox: "0 0 1457 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.7 51.23H0V290.35H103.7C178.35 290.35 215.72 248.35 215.72 164.29C215.72 88.95 178.34 51.23 103.7 51.23ZM97.02 251.88H44.35V89.69H97.02C146.61 89.69 171.38 114.57 171.38 164.28C171.38 222.66 146.61 251.88 97.02 251.88Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.83 49.57C282.76 49.57 242.76 90.09 242.76 171.13C246.3 251.71 286.36 292 362.83 292C441.58 292 481.02 251.71 481.02 171.13C481.02 90.09 441.58 49.57 362.83 49.57ZM362.83 253.54C313.41 253.54 288.75 225.74 288.75 170.16C288.75 115.43 313.41 88.04 362.83 88.04C410.94 88.04 435.02 115.43 435.02 170.16C435.03 225.74 410.94 253.54 362.83 253.54Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M628.13 49.57C548.06 49.57 508.05 90.09 508.05 171.13C511.59 251.71 551.65 292 628.13 292C706.88 292 746.32 251.71 746.32 171.13C746.33 90.09 706.89 49.57 628.13 49.57ZM628.13 253.54C578.71 253.54 554.05 225.74 554.05 170.16C554.05 115.43 578.7 88.04 628.13 88.04C676.24 88.04 700.32 115.43 700.32 170.16C700.33 225.74 676.24 253.54 628.13 253.54Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M938.06 89.69V51.23H756.64V89.69H825.18V290.35H869.52V89.69H938.06Z",
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.46 51.23L914.94 290.35H960.43L1039.18 96.89C1059.14 142.67 1067.94 165.69 1076 186.71H1018.19L1003.01 225.12H1091.21C1097.91 241.21 1106.67 261.24 1120.09 290.35H1167.75L1064.11 51.23H1016.46V51.23Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.7 177.93H1258.12H1258.11H1258.12L1169.68 290.34V290.35H1225.72L1288.01 211.65L1357.78 290.35H1413.82L1325.39 177.93H1314.7Z",
    fill: "#F8F8F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.7 168.1H1322.9H1325.48C1336.66 94.64 1442.06 12.62 1456.47 0H1430.79C1376.94 22.4 1311.56 63.13 1280.94 114.75L1240.72 63.62H1181.46L1263.64 168.09H1263.7V168.1Z",
    fill: "#19EA81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarcaDootax);
export default __webpack_public_path__ + "static/media/marca_dootax.dd118068179288a0ba84df195875a5f9.svg";
export { ForwardRef as ReactComponent };